import Vue from 'vue';
const EventBus = new Vue();

EventBus.onCartChangedEvent = 'on-cart-changed-event'
EventBus.onAnswerChangedEvent = 'on-answer-changed-event'

export default EventBus;
